import httpClient from '@/api/http-client'

const urlPrefix = '/bpm/v1/kanban'

export default {

  /**
   * Получение списка досок.
   *
   * @returns {*}
   */
  boards() {

    return httpClient.http
      .get( `${urlPrefix}/boards` )
      .then( response => {
        console.log( 'list status: ' + response.status )
        return response.data
      } )
  },

  /**
   * Подключение доски к модели.
   *
   * @param modelId
   * @param boardId
   * @returns {Promise<T>}
   */
  setBoard( modelId, boardId ) {

    return httpClient.http
      .patch( `${urlPrefix}/models/${modelId}/boards/${boardId}` )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Отключение доски от модели.
   *
   * @param modelId
   * @returns {Promise<T>}
   */
  resetBoard( modelId ) {

    return httpClient.http
      .delete( `${urlPrefix}/models/${modelId}/reset-board` )
      .then( response => {
        return response.data
      } )
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/kanban/api/settings/api.js